import React, { ReactNode, useEffect } from "react";
import LoginSideImage from "./../assects/img/login_side_pic.png"
import { useNavigate } from "react-router-dom";
import Alert from "../components/Alert";
import { loginCheck } from "../services/apiService";
import XoroBlack from "./../assects/img/XORO-Black-1080 (5).png"
import XoroWhite from "./../assects/img/XORO-White-1080 (4).png"
import { landingRoute } from "../utils/access"

interface LoginLayoutProps {
    children: ReactNode;
    isError: boolean;
    error: string | null;
    setIsError: any;
  }

const LoginLayout: React.FC<LoginLayoutProps> = ({children, isError, error, setIsError}) => {
    const navigate = useNavigate();

    useEffect(() => {
        const getData = async () => {
            const result = await loginCheck();
            localStorage.setItem('isLoggedIn', result.authenticated?.toString())
            const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
            if (isLoggedIn && result.authenticated) {
                navigate(landingRoute())
                window.location.reload();
            }
        }
        getData();
    }, [navigate]);

    const handleDismiss = (alertId: string) => {
        const alertElement = document.getElementById(alertId);
        if (alertElement) {
            setIsError(false);
            alertElement.style.display = 'none';
        }
    };
    
    return(
        <div className="w-full h-full flex">
            {isError &&
                <Alert
                    id="alert-2"
                    color="red"
                    iconColor="text-red-800 dark:text-red-400"
                    textColor="text-red-800 dark:text-red-400"
                    bgColor="bg-red-50 dark:bg-gray-800"
                    onDismiss={() => handleDismiss('alert-2')}
                >
                    {(error !== null &&  error !== "") ? error : "Some error happen"}
                </Alert>}
            <div className="w-1/2 h-[100vh] bg-black flex justify-center items-center">
                <div className="flex justify-center items-center">
                    <img src={XoroWhite} className="w-[70%]" />
                </div>
            </div>
            <div className="w-1/2 h-[100vh] flex justify-center items-center">
                {children}
            </div>
        </div>
    );
}
export default LoginLayout;